/* eslint-disable no-undef */
import { FunctionComponent } from 'react';
import CourseLanding from './../../components/courseLanding';
import SectionTitle from './../../components/sectionTitle';
import Conversation from './conversation';
import Conversations from './conversations';
import Animation002 from './animation002';
import Animation004 from './animation004';
import Animation006 from './animation006';
import Animation008 from './animation008';
import Animation009 from './animation009';
import Animation011 from './animation011';
import Animation014 from './animation014';
import Animation015 from './animation015';
import Animation016 from './animation016';
import Animation017 from './animation017';
import Animation018 from './animation018';
import Animation019 from './animation019';
import Animation095 from './animation095';
import Quiz from './../../components/quiz';
import Component001 from './component001';
import Component002 from './component002';
import Component003 from './component003';
import Component004 from './component004';
import Component008 from './component008';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Conversation,
  Conversations,
  Animation002,
  Animation004,
  Animation006,
  Animation008,
  Animation009,
  Animation011,
  Animation014,
  Animation015,
  Animation016,
  Animation017,
  Animation018,
  Animation019,
  Animation095,
  Component001,
  Component002,
  Component003,
  Component004,
  Component008,
};

export default Components;
